import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { Layout } from './components/Layout';
import { SimpleLayout } from './components/SimpleLayout';
import { Home } from './pages/Home';
import { Submit } from './pages/Submit';
import { Profile } from './pages/Profile';
import { TopRequests } from './pages/TopRequests';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Home page with no navbar */}
          <Route path="/" element={
            <SimpleLayout>
              <Home />
            </SimpleLayout>
          } />

          {/* Other pages with navbar */}
          <Route path="/submit" element={
            <Layout>
              <Submit />
            </Layout>
          } />
          <Route path="/profile" element={
            <Layout>
              <Profile />
            </Layout>
          } />
          <Route path="/top-requests" element={
            <Layout>
              <TopRequests />
            </Layout>
          } />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;